import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class TarifasService extends CrudService<any> {

  constructor(private config: AppConfigService, http: HttpClient) {
    super(config.TarifasUrl, http);
  }
  getTarifas(zonaId: number, tipoVehiculo: number) {
    let url = `${this.endpoint}/GetTarifas?zonaId=${zonaId}&tipoVehiculo=${tipoVehiculo}`
    return this.http.get<any>(url);
  }
  getTarifasViajeExpress(zonaId: number, tipoVehiculo: number) {
    let url = `${this.config.VentaRapidaUrl}/tarifas?zonaId=${zonaId}&tipoVehiculo=${tipoVehiculo}`
    return this.http.get<any>(url);
  }
}
